import { partial } from 'lodash/fp';
import api from './';

export const fetchContacts = partial(api.get, ['/contatos']);


// WEBPACK FOOTER //
// ./src/api/contacts.js